import React, { useEffect, useState } from "react";
import { Button, Text } from "components";
import Modal from "react-modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Swal from "sweetalert2";

function DeliveryChallanEwayBill() {
  const [visible, setvisible] = useState(true);
  const [transportMode, setTransportMode] = useState([]);
  const [transporter, setTransporter] = useState([]);
  const [selectedTransporter, setselectedTransporter] = useState("Yes");
  const [transdocvalidation, setTransdocvalidation] = useState();
  //   const [taxinvoice, setTaxInvoice] = useState([]);
  let navigate = useNavigate();
  const { id } = useParams();

  const token = sessionStorage.getItem("token");

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const obj = {};
  useEffect(() => {
    transportModeGet();
    TransporterGet();
    // GetTaxInvoice();
  }, []);

  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 49 && item.add
  );

  const transportMode_obj = {};
  const transportModeGet = () => {
    axios
      .post("/api/purple-fusion/transportmode/get", transportMode_obj, headers)
      .then((response) => {
        setTransportMode(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const Transporter_obj = {};
  const TransporterGet = () => {
    axios
      .post("/api/purple-fusion/transport/get", Transporter_obj, headers)
      .then((response) => {
        setTransporter(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/;
  const alphanumericRegex = /^[A-Za-z0-9]{4,20}$/;
  const validationSchema =
    transdocvalidation == 1
      ? Yup.object().shape({
          transMode: Yup.string().required("Please Select Transport Mode"),
          transDistance: Yup.string().required("transDistance is required"),
          transporterId: Yup.string()
            .matches(gstinRegex, "Please enter a valid GSTIN")
            .min(15, "GSTIN must be exactly 15 characters")
            .max(15, "GSTIN must be exactly 15 characters")
            .required("GSTIN is required"),
          transporterName: Yup.string().required(
            "Transporter name  is required"
          ),
          vehicleNo: Yup.string()
            .matches(
              alphanumericRegex,
              "Vehicle number must be alphanumeric and between 4 and 20 characters"
            )
            .required("Vehicle number is required"),
          vehicleType: Yup.string().required("Please Select vehicle type"),
        })
      : Yup.object().shape({
          transMode: Yup.string().required("Please Select Transport Mode"),
          transDistance: Yup.string().required("transDistance is required"),
          transporterId: Yup.string()
            .matches(gstinRegex, "Please enter a valid GSTIN")
            .min(15, "GSTIN must be exactly 15 characters")
            .max(15, "GSTIN must be exactly 15 characters")
            .required("GSTIN is required"),
          transporterName: Yup.string().required(
            "Transporter name  is required"
          ),
          vehicleNo: Yup.string()
            .matches(
              alphanumericRegex,
              "Vehicle number must be alphanumeric and between 4 and 20 characters"
            )
            .required("Vehicle number is required"),
          vehicleType: Yup.string().required("Please Select vehicle type"),
          transDocDate: Yup.string().required("Documents date is required"),
          transDocNo: Yup.string().required("Documents number is required"),
        });

  const formik = useFormik({
    initialValues: {
      transMode: "",
      transDistance: "",
      transporterId: "",
      transporterName: "",
      vehicleNo: "",
      vehicleType: "",
      transDocDate: "",
      transDocNo: "",
      delivery_challan_id: id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleTransporterChange = (event) => {
    const selection = event.target.value;
    setselectedTransporter(selection);

    // If selection is "Yes", populate Transport Name and GSTIN
    if (selection === "Yes") {
      // Assuming transporter data is available in state
      const selectedTransporterData = transporter.find(
        (item) => item.name === formik.values.transporterName
      );
      if (selectedTransporterData) {
        formik.setValues({
          ...formik.values,
          transporterName: selectedTransporterData.name,
          transporterId: selectedTransporterData.gstin,
        });
      } else {
        // Handle the case when the selected transporter is not found in the data
        // You can show a message or reset the fields
      }
    } else {
      // Clear the Transport Name and GSTIN fields if selection is "No"
      formik.setValues({
        ...formik.values,
        transporterName: "",
        transporterId: "",
      });
    }
  };
  const errorMessage = `<a target="_blank" href="https://docs.ewaybillgst.gov.in/apidocs/api-error-codes-list.html"  style="color: #00f; text-decoration: underline;">Error List</a>`;
  const handleFormSubmit = (values) => {
    console.log(values);

    Swal.fire({
      title: "Processing...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios
      .post("/api/purple-fusion/ewaybill/getinvoicedetails", values, headers)
      .then((response) => {
        console.log(response.data);

        let message = response.data.message;
        message = message.replace(/[\[\]{}\/\\"']/g, "");
        message = message.replace(/[\,\;]/g, "\n");
        console.log(message);
        Swal.close(); // Close the Swal modal here
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                navigate("/delivarychallan/list");
              },
            })
          : toast.error(
              <div
                dangerouslySetInnerHTML={{ __html: message + errorMessage }}
              />,
              {
                // autoClose: 2000,
                autoClose: false,
                onClose: () => {
                  // setvisible(false);
                  // navigate("/supplierList");
                },
              }
            );
      })
      .catch((error) => {
        console.log(error);
        Swal.close();
        setvisible(false);
        navigate("*");
      });
  };

  const customStyles = {
    content: {
      width: "70%",
      height: "80%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };

  return (
    <div>
      {/* {showActionColumn ? ( */}
      <div>
        <Modal
          isOpen={visible}
          style={customStyles}
          onRequestClose={() => {
            // setvisible(false);
            // navigate("/taxinvoice/list");
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
              <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                <div className="flex flex-1 flex-col gap-[10px] justify-start md:px-5 w-full">
                  <div className="flex flex-row ml-auto mt-0  top-2 w-[100%]">
                    <div className="flex flex-row sm:gap-12 items-center justify-start w-full ">
                      <Text
                        className="mt-[-20px] md:text-xl sm:text-[24px] text-[20px] text-black-700 tracking-[0.20px] "
                        size="txtInterMedium24"
                      >
                        Generate EwayBill
                      </Text>
                    </div>

                    <div className="flex flex-row sm:gap-12 items-center justify-end w-full ">
                      <Button
                        className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] mt-[-20px] active:scale-90 transition-transform duration-200"
                        shape="round"
                        color="blue_A700"
                        size="base"
                        variant="fill"
                        type="submit"
                        // onClick={(e) => onHandleSubmit(e)}
                      >
                        Save
                      </Button>
                      <Button
                        className="cursor-pointer font-small mb-6 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] "
                        shape="round"
                        color="white"
                        size="base"
                        variant="fill"
                        type="button"
                        onClick={() => {
                          setvisible(false);
                          navigate("/delivarychallan/list");
                        }}
                      >
                        ╳
                      </Button>
                    </div>
                  </div>
                  <div className="flex flex-col items-center justify-start md:ml-[0] ml-[25px] w-[87%] md:w-full ">
                    <ToastContainer />
                    <div className="md:gap-5 gap-y-[20px] gap-x-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full ">
                      <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-900 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black700"
                        >
                          <span className="text-black-700 font-inter font-small">
                            Existing Transporter
                          </span>
                          <span className="text-red-A700 font-inter font-samll">
                            *
                          </span>
                        </Text>
                        <div className="flex items-center justify-start gap-4">
                          <label>
                            <input
                              type="radio"
                              value="Yes"
                              checked={selectedTransporter === "Yes"}
                              onChange={handleTransporterChange}
                            />
                            Yes
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="NO"
                              checked={selectedTransporter === "NO"}
                              onChange={handleTransporterChange}
                            />
                            No
                          </label>
                        </div>
                      </div>
                      <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black700"
                        >
                          <span className="text-black-700 font-inter font-small">
                            Transport Mode
                          </span>
                        </Text>
                        <Select
                          name="transMode"
                          options={transportMode?.map((resstate) => ({
                            label: resstate.name,
                            value: resstate.id,
                          }))}
                          className="bg-white-A700 border border-gray-200_02 border-solid h-[40px] rounded-[10px] w-full"
                          onChange={(selectedOption) => {
                            formik.setFieldValue(
                              "transMode",
                              selectedOption.value
                            );
                            setTransdocvalidation(selectedOption.value);
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Select Transport Mode"
                        />
                        {formik.touched.transMode && formik.errors.transMode ? (
                          <div className="text-red-500">
                            {formik.errors.transMode}
                          </div>
                        ) : null}
                      </div>
                      {selectedTransporter === "Yes" && (
                        <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full mt-0">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black700"
                          >
                            <span className="text-black-700 font-inter font-small">
                              Select Transporter
                            </span>
                          </Text>
                          <Select
                            name="transporterName"
                            options={transporter?.map((resstate) => ({
                              label: resstate.name,
                              value: resstate.name,
                              gstnumber: resstate.gstnumber,
                            }))}
                            className="bg-white-A700 border border-gray-200_02 border-solid h-[40px] rounded-[10px] w-full"
                            onChange={(selectedOption) => {
                              formik.setFieldValue(
                                "transporterName",
                                selectedOption.value
                              );
                              formik.setFieldValue(
                                "transporterId",
                                selectedOption.gstnumber
                              );
                            }}
                            onBlur={formik.handleBlur}
                            placeholder="Select Transporter"
                          />
                          {formik.touched.transporterName &&
                          formik.errors.transporterName ? (
                            <div className="text-red-500">
                              {formik.errors.transporterName}
                            </div>
                          ) : null}
                        </div>
                      )}
                      <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black900"
                        >
                          <span className="text-black-700 font-inter font-small">
                            Transport Distance
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </Text>
                        <input
                          name="transDistance"
                          type="text"
                          placeholder=" Enter transDistance"
                          // value={supplier.name}
                          // onChange={handleInputChange}
                          value={formik.values.transDistance}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                        ></input>
                        {formik.touched.transDistance &&
                        formik.errors.transDistance ? (
                          <div className="text-red-500">
                            {formik.errors.transDistance}
                          </div>
                        ) : null}
                      </div>
                      {selectedTransporter === "NO" && (
                        <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full ">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small">
                              GSTIN
                            </span>
                            <span className="text-red-A700 font-inter font-small">
                              *
                            </span>
                          </Text>
                          <input
                            name="transporterId"
                            type="text"
                            placeholder=" Enter GSTIN"
                            // value={supplier.addressline1}
                            // onChange={handleInputChange}
                            value={formik.values.transporterId}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                          ></input>
                          {formik.touched.transporterId &&
                          formik.errors.transporterId ? (
                            <div className="text-red-500">
                              {formik.errors.transporterId}
                            </div>
                          ) : null}
                        </div>
                      )}
                      {selectedTransporter === "NO" && (
                        <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small">
                              Transport Name
                            </span>
                            <span className="text-red-A700 font-inter font-small">
                              *
                            </span>
                          </Text>
                          <input
                            name="transporterName"
                            type="text"
                            placeholder=" Enter Transport Name"
                            // value={supplier.addressline2}
                            // onChange={handleInputChange}
                            value={formik.values.transporterName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                          ></input>
                          {formik.touched.transporterName &&
                          formik.errors.transporterName ? (
                            <div className="text-red-500">
                              {formik.errors.transporterName}
                            </div>
                          ) : null}
                        </div>
                      )}
                      <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black900"
                        >
                          <span className="text-black-700 font-inter font-small">
                            Vehicle Number
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </Text>
                        <input
                          name="vehicleNo"
                          type="text"
                          placeholder=" Enter Vehicle Number"
                          // value={supplier.addressline2}
                          // onChange={handleInputChange}
                          value={formik.values.vehicleNo}
                          // onChange={formik.handleChange}
                          onChange={(event) => {
                            const newValue = event.target.value.replace(
                              /[^a-zA-Z0-9]/g,
                              ""
                            );
                            formik.handleChange({
                              target: {
                                name: "vehicleNo",
                                value: newValue,
                              },
                            });
                          }}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                        ></input>
                        {formik.touched.vehicleNo && formik.errors.vehicleNo ? (
                          <div className="text-red-500">
                            {formik.errors.vehicleNo}
                          </div>
                        ) : null}
                      </div>
                      <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black900"
                        >
                          <span className="text-black-700 font-inter font-small">
                            Vehicle Type
                          </span>
                          <span className="text-red-A700 font-inter font-small">
                            *
                          </span>
                        </Text>

                        <Select
                          name="vehicleType"
                          options={[
                            { label: "Regular", value: "R" },
                            {
                              label: "ODC (Over Dimentional Cargo)",
                              value: "O",
                            },
                          ]}
                          className="bg-white-A700 border border-gray-200_02 border-solid h-[40px] rounded-[10px] w-full"
                          onChange={(selectedOption) => {
                            formik.setFieldValue(
                              "vehicleType",
                              selectedOption.value
                            );
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Select Vehicle Type"
                        />
                        {formik.touched.vehicleType &&
                        formik.errors.vehicleType ? (
                          <div className="text-red-500">
                            {formik.errors.vehicleType}
                          </div>
                        ) : null}
                      </div>
                      {(formik.values.transMode === 2 ||
                        formik.values.transMode === 3 ||
                        formik.values.transMode === 4) && (
                        <div>
                          <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small">
                                Transport Documnet Number
                              </span>
                              <span className="text-red-A700 font-inter font-small">
                                *
                              </span>
                            </Text>
                            <input
                              name="transDocNo"
                              type="text"
                              placeholder=" Enter Transport Documnet Number"
                              value={formik.values.transDocNo}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                            ></input>
                            {formik.touched.transDocNo &&
                            formik.errors.transDocNo ? (
                              <div className="text-red-500">
                                {formik.errors.transDocNo}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      )}
                      {(formik.values.transMode === 2 ||
                        formik.values.transMode === 3 ||
                        formik.values.transMode === 4) && (
                        <div className="flex flex-1 flex-col gap-[16px] items-start justify-start w-full mt-0">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small">
                              Transport Document Date
                            </span>
                            <span className="text-red-A700 font-inter font-small">
                              *
                            </span>
                          </Text>
                          <input
                            name="transDocDate"
                            type="Date"
                            placeholder=" Enter Trans Documnet Date"
                            // value={supplier.addressline2}
                            // onChange={handleInputChange}
                            value={formik.values.transDocDate}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                          ></input>
                          {formik.touched.transDocDate &&
                          formik.errors.transDocDate ? (
                            <div className="text-red-500">
                              {formik.errors.transDocDate}
                            </div>
                          ) : null}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      </div>
      {/*  ) : (
   <div className="flex justify-center items-center h-screen">
     <div className="text-4xl text-red-500">No Access</div>
  </div>
 )} */}
    </div>
  );
}

export default DeliveryChallanEwayBill;
